import * as React from 'react';

export interface ISuggestionProps {
    searchSuggestionText: string;
    suggestion: string;
    loading: boolean;

    onSuggestionClick: () => void;
}

export function SearchSuggestion({ searchSuggestionText, suggestion, loading, onSuggestionClick }: ISuggestionProps) {
    if (!suggestion || suggestion.length < 1 || loading) {
        return null;
    }

    return (
        <p className="adage-search-suggestion">
            {searchSuggestionText} <a href="#" className="search-suggestion-link" onClick={onSuggestionClick}>{suggestion}</a>?
        </p>
    );
};
